import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';

export default styled(Paper)(
  p => `
  box-shadow: ${p.theme.effects.boxShadow};
`
);
